import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: 100%;
  height: 64px;
  flex-shrink: 0;
  background-color: #363636;
`;
